// Centralized backend URL resolver.
// Fixes deployment scenarios where the frontend is served on a custom domain
// (e.g., gestao.mercadobestby.com.br) but the build embedded the original
// Emergent deployment URL (e.g., finstock-7.emergent.host).
//
// Strategy:
// 1. If REACT_APP_BACKEND_URL is set and matches the current hostname -> use it
// 2. If running on a different host than the baked URL -> use window.location.origin (same-origin)
// 3. Fallback to window.location.origin

const baked = process.env.REACT_APP_BACKEND_URL || "";

function resolveBackendUrl() {
  if (typeof window === "undefined") {
    return baked;
  }
  try {
    if (baked) {
      const bakedHost = new URL(baked).hostname;
      // Same host? Trust the baked URL.
      if (bakedHost === window.location.hostname) {
        return baked;
      }
      // Different host = custom domain / different deployment -> use current origin
      return window.location.origin;
    }
  } catch (_) {
    // Malformed baked URL - fall through
  }
  return window.location.origin;
}

export const BACKEND_URL = resolveBackendUrl();
export const API = `${BACKEND_URL}/api`;
